import { render } from "./EnrollForm.vue?vue&type=template&id=7c8059cd&scoped=true"
import script from "./EnrollForm.vue?vue&type=script&lang=js"
export * from "./EnrollForm.vue?vue&type=script&lang=js"

import "./EnrollForm.vue?vue&type=style&index=0&id=7c8059cd&scoped=true&lang=css"

import exportComponent from "/var/www/tis-live/frontend/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8059cd"]])

export default __exports__